import { render, staticRenderFns } from "./MPlatformProcessing.vue?vue&type=template&id=21c7df5a&lang=pug&"
import script from "./MPlatformProcessing.vue?vue&type=script&lang=js&"
export * from "./MPlatformProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports